import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectClientField');

    return {
        CLIENT: t('client'),
        CLIENT_IS_REQUIRED: t('clientIsRequired')
    };
};

export default useTranslation;
